import {IconWrapper} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  "data-slot": "icon",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M21.15 12a9.15 9.15 0 1 1-18.3 0 9.15 9.15 0 0 1 18.3 0Z" }, null, -1),
    _createElementVNode("path", { d: "M17 12a5 5 0 1 1-10 0 5 5 0 0 1 10 0Z" }, null, -1),
    _createElementVNode("path", { d: "M13 12a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z" }, null, -1)
  ])))
}
export default { render() { return h(IconWrapper, {icon: {render}, name: "focus"}) } }